import { render, staticRenderFns } from "./replacementDetails.vue?vue&type=template&id=6e7665f8&scoped=true&"
import script from "./replacementDetails.vue?vue&type=script&lang=js&"
export * from "./replacementDetails.vue?vue&type=script&lang=js&"
import style0 from "./replacementDetails.vue?vue&type=style&index=0&id=6e7665f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7665f8",
  null
  
)

export default component.exports